<section class="filing-status-dialog">
    <div class="filing-status-dialog-header uscb-layout-row uscb-bg-primary uscb-color-white">
        <span class="vcenter uscb-flex uscb-padding-TB-0 uscb-padding-LR-8 filing-status-dialog-title">{{filingStatusDialogData?.title || 'Filing Status'}}</span>
        <span class="vcenter filing-status-dialog-close">
            <mat-icon (click)="close(true)" (keyup.enter)="close(true)" tabindex="0" aria-hidden="false">close</mat-icon>
        </span>
    </div>
    <mat-dialog-content>
        @if (currentSurvey()) {
        <div class="my-dialog-content md-dialog-content bottom-padding-md">
            <h4 class="md-subhead uscb-font-1x">{{currentSurvey()?.displayName}}</h4>
            <h4 class="md-subhead uscb-disaply-inline-block">{{currentSurvey()?.organizationName}}</h4>
            <span class="float-right uscb-line-height-32">({{currentTotalReceived()}} of {{currentTotalElements()}} Received)</span>
            <div class="uscb-font-sm uscb-margin-T-5 uscb-margin-B-15"><b>Note:</b> Survey card and Options menu will remain
                accessible for duration of survey period.</div>
            <table class="dialog-table uscb-width-100" [class.filing-status-table-loading]="isSendingRequest()" [attr.aria-busy]="isSendingRequest()">
                <tr>
                    <th class="dialog-th ecorr-filing-unit uscb-text-align-center" (click)="reorder('unitId')" (keyup.enter)="reorder('unitId')" [attr.aria-sort]="ariaSort('unitId')" tabindex="0">
                        Unit ID
                        <i class="fa" [ngClass]="fasClass('unitId')"></i>
                    </th>
                    <th class="dialog-th ecorr-filing-name uscb-text-align-center" (click)="reorder('organizationNameLine1')" (keyup.enter)="reorder('organizationNameLine1')" [attr.aria-sort]="ariaSort('organizationNameLine1')" tabindex="0">
                        Name
                        <i class="fa" [ngClass]="fasClass('organizationNameLine1')"></i>
                    </th>
                    <th class="dialog-th ecorr-filing-address uscb-text-align-center" (click)="reorder('city')" (keyup.enter)="reorder('city')" [attr.aria-sort]="ariaSort('city')" tabindex="0">
                        Address
                        <i class="fa" [ngClass]="fasClass('city')"></i>
                    </th>
                    <th class="dialog-th ecorr-filing-state uscb-text-align-center" (click)="reorder('state')" (keyup.enter)="reorder('state')" [attr.aria-sort]="ariaSort('state')" tabindex="0">
                        State
                        <i class="fa" [ngClass]="fasClass('state')"></i>
                    </th>
                    <th class="dialog-th ecorr-filing-store uscb-text-align-center" (click)="reorder('storeNumber')" (keyup.enter)="reorder('storeNumber')" [attr.aria-sort]="ariaSort('storeNumber')" tabindex="0">
                        Store Num
                        <i class="fa" [ngClass]="fasClass('storeNumber')"></i>
                    </th>
                    <th class="dialog-th ecorr-filing-form uscb-text-align-center" (click)="reorder('surveyFormName')" (keyup.enter)="reorder('surveyFormName')" [attr.aria-sort]="ariaSort('surveyFormName')" tabindex="0">
                        Form
                        <i class="fa" [ngClass]="fasClass('surveyFormName')"></i>
                    </th>
                    <th class="dialog-th ecorr-filing-received uscb-text-align-center" (click)="reorder('completionDate')" (keyup.enter)="reorder('completionDate')" [attr.aria-sort]="ariaSort('completionDate')" tabindex="0">
                        Date Received
                        <i class="fa" [ngClass]="fasClass('completionDate')"></i>
                    </th>
                </tr>
                @for (form of currentForms(); track form.unitId) {
                <tr>
                    <td class="dialog-td sm-td">{{form.unitId}}</td>
                    <td class="dialog-td sm-td">{{form.organizationNameLine1}}</td>
                    <td class="dialog-td sm-td">
                        {{form.organizationAddresses[0].addressLine1 + ", " +  form.organizationAddresses[0].city}}
                    </td>
                    <td class="dialog-td sm-td">{{form.organizationAddresses[0].state}}</td>
                    <td class="dialog-td sm-td">{{form.storeNumber}}</td>
                    <td class="dialog-td sm-td">{{form.surveyFormName}}</td>
                    <td class="dialog-td sm-td">{{form.completionDate | date:'yyyy-MM-dd'}}</td>
                </tr>
                }
            </table>
            <!--
            <mat-paginator appAppStylePaginator style-paginator showFirstLastButtons [length]="totalElements" [pageSize]="10" (page)="page($event)">
            </mat-paginator>
            -->

            <!-- TODO: tmp pagination fix start. Not tested for more than 100 totalElements -->
            <div class="uscb-layout-row uscb-layout-align-center-center filing-status-pager">
                <button class="uscb-transparent-button uscb-bg-white uscb-margin-T-20 filing-status-page-arrow" (click)="pageChange('left')" (keyup.enter)="pageChange('left')"
                    [disabled]="!hasMoreOnLeft() || isSendingRequest()" [style]="{'cursor' : hasMoreOnLeft() ? 'pointer' : 'default'}"
                    aria-label="Previous page" tabindex="0">
                    <i class="fa fa-angle-left fa-2x calnav" aria-hidden="true"></i>
                </button>
                @for (item of getPagingList(); track item) {
                <button class="uscb-primary-button uscb-margin-T-20 uscb-font-md uscb-cursor-pointer-hover filing-status-page-number"
                    [disabled]="currentPageIndex() == (item - 1) || isSendingRequest()"
                    [style]="{'cursor' : (currentPageIndex() == (item - 1)) ? 'default' : 'pointer'}" (click)="pageItem(item)" (keyup.enter)="pageItem(item)" tabindex="0">
                    {{ item }}
                </button>
                }
                <button class="uscb-transparent-button uscb-bg-white uscb-margin-T-20 filing-status-page-arrow" (click)="pageChange('right')" (keyup.enter)="pageChange('right')"
                    [disabled]="!hasMoreOnRight() || isSendingRequest()" [style]="{'cursor' : hasMoreOnRight() ? 'pointer' : 'default'}"
                    aria-label="Next page" tabindex="0">
                    <i class="fa fa-angle-right fa-2x calnav" aria-hidden="true"></i>
                </button>
            </div>
            <!-- TODO: tmp pagination fix End -->

            <div class="uscb-text-align-center uscb-margin-T-5">
                @if (currentForms().length) {
                Viewing {{viewingStart()}}–{{viewingEnd()}} of {{currentTotalElements()}}
                } @else {
                Viewing 0 of {{currentTotalElements()}}
                }
            </div>
        </div>
        }
    </mat-dialog-content>
    <app-linear-loading [loading]="isSendingRequest()"></app-linear-loading>
    <mat-dialog-actions class="filing-status-actions uscb-margin-T-10 uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
        <button type="button" class="uscb-secondary-button uscb-flex-row ecorr-width-min-120px"
            (click)="cancel()" (keyup.enter)="cancel()" tabindex="0">{{filingStatusDialogData?.cancelButtonLabel || 'Close'}}</button>
        @if (isExporting()) {
        <ng-container>
            <div> Please wait. Loading... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i> </div>
        </ng-container>
        }
        @if (!isExporting()) {
        <ng-container>
            <div
                class="dropdown-button-group uscb-flex-row uscb-layout-row-gt-md uscb-layout-column-md uscb-layout-column-sm uscb-layout-align-center-center">
                <button type="button" [disabled]="safariCheck()" title="Export" (mouseover)="onExport()" (mouseout)="offExport()"
                    class="uscb-primary-button uscb-flex-row ecorr-width-min-120px" (click)="exportOps.set(!isExportOps())" (keyup.enter)="exportOps.set(!isExportOps())" tabindex="0">
                    {{filingStatusDialogData?.confirmButtonLabel || 'Export'}} &nbsp;
                    <i class="fa fa-caret-down"></i>
                </button>
                @if (isExportOps()) {
                <ul class="dropdown-menu bottom-padding-sm" (mouseover)="onUl()" (mouseout)="offUl()">
                    <li><a (click)="exportStatus('xls')" (keyup.enter)="exportStatus('xls')" tabindex="0">XLS</a></li>
                    <li><a (click)="exportStatus('csv')" (keyup.enter)="exportStatus('csv')" tabindex="0">CSV</a></li>
                </ul>
                }
            </div>
        </ng-container>
        <br>
        @if (safariCheck()) {
        <span class="center-text top-padding">Export filing status not supported on Safari</span>
        }
        <br>
        }
    </mat-dialog-actions>
</section>